<template>
  <div>
    <div class="banner" @click="openConcat">
      <div class="banner_title">开通属于自己的网站</div>
      <div class="banner_sub_title">
        网站完全独立控制 · 全天24小时自动售单 · 无需人工干预
      </div>
      <div class="banner_btn">咨询客服</div>
    </div>
    <div class="advantage">
      <div class="advantage_title">产品优势</div>
      <div class="advantage_list">
        <div
          class="advantage_list_item"
          v-for="(item, index) in advantageList"
          :key="index"
        >
          <img :src="item.icon" alt="" />
          <div class="title">{{ item.title }}</div>
          <div class="desc">{{ item.info }}</div>
        </div>
      </div>
    </div>
    <div class="join_step">
      <div class="join_step_title">开通分站仅需6步</div>
      <div class="join_step_list">
        <div
          class="join_step_item"
          v-for="(item, index) in joinStep"
          :key="index"
        >
          <div class="join_step_item_title">
            <span class="num">{{ index + 1 }}</span>
            <span class="text">{{ item.title }}</span>
          </div>
          <div class="join_step_item_body">
            {{ item.info }}
          </div>
        </div>
      </div>
    </div>
    <div class="profit">
      <div class="profit_title">盈利模式</div>
      <div class="profit_step">
        <div class="profit_step_item">
          <img src="@/assets/one.png" alt="" />
          <div class="text">注册会员</div>
          <div class="text">并开通分站</div>
        </div>
        <div class="profit_step_item">
          <img src="@/assets/two.png" alt="" />
          <div class="text">邀请好友</div>
          <div class="text">成功下单或开站</div>
        </div>
        <div class="profit_step_item">
          <img src="@/assets/three.png" alt="" />
          <div class="text">获得订单佣金</div>
          <div class="text">开展佣金</div>
        </div>
      </div>
      <div class="invite_step">
        <div class="invite_step_item">
          <img src="@/assets/img／被邀请人.png" alt="" />
          <div class="title">被邀请人</div>
        </div>
        <div class="invite_step_jiantou">
          <img src="@/assets/img／箭头.png" alt="" />
        </div>
        <div class="invite_step_item">
          <img src="@/assets/img／邀请人.png" alt="" />
          <div class="title">邀请人</div>
        </div>
      </div>
      <div class="invite_text">
        <div class="invite_text_item">
          <div class="text">
            注册账号，成功<span class="red">开通B分站</span>
          </div>
          <div class="text">
            并且完成<span class="red">N笔订单</span>

            交易
          </div>
        </div>
        <div class="invite_text_item">
          <div class="text">A分站将获得<span class="red">开站佣金</span></div>
          <div class="text">以及N笔订单的<span class="red">提成佣金</span></div>
        </div>
      </div>
      <div class="calculate">
        <div>* 订单提成佣金=B分站成本-A分站成本（A分站可设置B分站成本）</div>

        <div>* B分站再发展分站，开站和提成佣金由B分站获得，A分站无佣金；</div>
      </div>
    </div>
    <div class="join_now" v-show="agent_show">
      <van-button
        v-if="agentLevel.price"
        round
        type="info"
        size="normal"
        color="#F93244"
        class="update_btn"
        @click="joinNow(agentLevel.id)"
      >
        开通分站（特惠￥{{ agentLevel.price }}）</van-button
      >
      <van-button
        v-else
        round
        type="info"
        size="normal"
        color="#F93244"
        class="update_btn"
        @click="loginfirst"
      >
        开通分站</van-button
      >
    </div>
  </div>
</template>

<script>
import icon1 from '@/assets/icon／技术支持.png';
import icon2 from '@/assets/icon／独立域名.png';
import icon3 from '@/assets/icon／API接口.png';
import icon4 from '@/assets/icon／安全稳定.png';
import icon5 from '@/assets/icon／分站成本低.png';
import icon6 from '@/assets/icon／建站速度快.png';
import icon7 from '@/assets/icon／账户.png';
import icon8 from '@/assets/icon／前景可观.png';
import Vue from 'vue';
import { oemGet, agentLevelAll, agentOrderGet } from '@/api';
export default {
  data() {
    return {
      advantageList: [
        {
          icon: icon1,
          title: '技术支持',
          info: '24小时提供在线维护'
        },
        {
          icon: icon2,
          title: '独立域名',
          info: '独立后台、自由管理'
        },
        {
          icon: icon3,
          title: '网站API接口',
          info: '无需任何费用'
        },
        {
          icon: icon4,
          title: '稳定安全',
          info: '低价快递费+礼品货源'
        },
        {
          icon: icon5,
          title: '分站成本低',
          info: '提供维护、升级服务'
        },
        {
          icon: icon6,
          title: '建站速度快',
          info: '10分钟即可实现建站'
        },
        {
          icon: icon7,
          title: '随时提现',
          info: '利润直达账户'
        },
        {
          icon: icon8,
          title: '前景可观',
          info: '客源稳定、收入稳定'
        }
      ],
      joinStep: [
        {
          title: '注册账号',
          info: '注册会员账号，若已有账号，直接在登录界面登录'
        },
        {
          title: '申请代理',
          info: '进入礼品商城，在“网站管理”点击“开通”申请分站'
        },
        {
          title: '支付费用',
          info: '按照操作流程，点击付费'
        },
        {
          title: '网站配置',
          info: '设置网站域名、名称等信息，等待系统审核'
        },
        {
          title: '开通成功',
          info: '系统审核通过后，分站即开通成功，可立即投入使用'
        },
        {
          title: '推广盈利',
          info: '对已上线的分站进行运营管理、推广管理'
        }
      ],
      agent_show: true,
      agentLevel: {}
    };
  },
  created() {
    oemGet().then((res) => {
      if (res.success) {
        this.agent_show = false;
      } else {
        this.agent_show = true;
      }
    });
    agentLevelAll().then((res) => {
      if (res.success) {
        this.agentLevel = res.data[0];
      }
    });
  },

  methods: {
    openConcat() {
      window.open(
        'https://yzf.qq.com/xv/web/static/chat/index.html?sign=37ef9b97817c5390744c9abd4ae0e0344549e2a29e6fdc2fdf2b2137a1eaebae5c0f1ad81b0ab6a09db04a4b9520996e25ff7c'
      );
    },
    loginfirst() {
      this.$toast.fail('请先登录');
      setTimeout(() => {
        this.$router.push({
          path: '/login',
          query: { redirect: '/join' }
        });
      }, 500);
    },
    joinNow(agentLevelId) {
      agentOrderGet({ agentLevelId: agentLevelId }).then((res) => {
        if (res.success) {
          const unpay = {
            id: res.data.id,
            goods: {
              name: '开通分站'
            },
            amount: this.agentLevel.price,
            agent: 1
          };
          Vue.ls.set('unpay', unpay);
          this.$router.push('/orderPay');
        } else {
          this.$toast.fail(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.banner {
  background-image: url(~@/assets/join_bg.png);
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 11.2vw;
  &_title {
    font-size: 8.533vw;
    font-weight: 500;
    color: #ffffff;
    text-shadow: 0px 3px 20px rgba(244, 57, 71, 0.15);
  }
  &_sub_title {
    font-size: 2.933vw;
    color: #ffffff;
    margin-top: 2.133vw;
    margin-bottom: 6.4vw;
  }
  &_btn {
    width: 52.533vw;
    height: 8.533vw;
    background: #ffffff;
    border-radius: 5.867vw;
    font-size: 3.733vw;
    color: #f85539;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 9.6vw;
  }
}
.advantage {
  background: #f7f8fa;
  padding-top: 6.4vw;
  &_title {
    font-size: 5.333vw;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 5.333vw;
    text-align: center;
  }
  &_list {
    display: flex;
    flex-wrap: wrap;
    padding: 0 4.267vw 0.8vw;

    &_item {
      width: 48%;
      height: 27.467vw;
      background: #ffffff;
      margin-bottom: 3.2vw;
      border-radius: 16px;
      padding-top: 4.267vw;
      text-align: center;
      &:nth-child(2n-1) {
        margin-right: 3.2vw;
      }

      img {
        width: 6.4vw;
        height: 6.4vw;
        margin-bottom: 3.2vw;
      }
      .title {
        font-size: 4vw;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 2.133vw;
      }
      .desc {
        font-size: 3.2vw;
        color: #707070;
      }
    }
  }
}
.join_step {
  background-image: url(~@/assets/join_bg2.png);
  background-size: cover;
  padding-top: 7.467vw;
  padding-bottom: 5.333vw;
  &_title {
    margin-bottom: 6.4vw;
    font-size: 5.333vw;
    color: #fff;
    text-align: center;
  }
  &_list {
    padding: 0 4.267vw;
    display: flex;
    flex-wrap: wrap;
    .join_step_item {
      width: 48%;
      margin-bottom: 4.267vw;
      &:nth-child(2n-1) {
        margin-right: 3.2vw;
      }
      &_title {
        font-size: 3.733vw;
        margin-bottom: 2.133vw;
        .num {
          font-size: 4.533vw;
          font-family: Roboto;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          margin-right: 1.6vw;
        }
        .text {
          font-size: 3.733vw;
          color: rgba(255, 255, 255, 1);
        }
      }

      &_body {
        height: 15.067vw;
        line-height: 4.267vw;
        background: #fff;
        border-radius: 1.067vw;
        font-size: 3.2vw;
        display: flex;
        align-items: center;
        padding: 0 2.133vw;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
}
.profit {
  &_title {
    font-size: 5.333vw;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin: 7.467vw 0;
    text-align: center;
  }
  &_step {
    display: flex;
    margin-bottom: 6.667vw;
    &_item {
      flex: 1;
      text-align: center;

      img {
        width: 7.467vw;
        height: 7.467vw;
        margin-bottom: 3.2vw;
      }
      .text {
        font-size: 3.2vw;

        font-weight: 600;
        color: #f93244;
        line-height: 4.267vw;
      }
    }
  }
  .invite_step {
    display: flex;

    &_item {
      flex: 1;
      text-align: center;
      img {
        width: 10.667vw;
        height: 10.667vw;
        margin-bottom: 1.067vw;
      }
      .title {
        font-size: 3.2vw;
        color: rgba(0, 0, 0, 0.85);

        margin-bottom: 2.667vw;
      }
    }
    &_jiantou {
      display: flex;
      align-items: center;
      img {
        width: 7.2vw;
        height: 3.667vw;
      }
    }
  }
  .invite_text {
    display: flex;
    margin-bottom: 4.267vw;
    &_item {
      flex: 1;
      font-size: 2.667vw;
      .text {
        text-align: center;
        font-size: 2.667vw;
        line-height: 3.733vw;
        color: rgba(0, 0, 0, 0.65);
      }
      .red {
        color: #f93244;
        font-size: 2.667vw;
      }
    }
  }
  .calculate {
    margin-bottom: 9.2vw;
    text-align: center;
    div {
      font-size: 2.667vw;
      color: rgba(0, 0, 0, 0.45);
      line-height: 3.733vw;
    }
  }
}
.join_now {
  display: flex;
  justify-content: center;
  margin-bottom: 12.267vw;
  .update_btn {
    width: 82.933vw;
    height: 11.733vw;
  }
}
</style>
